export default "__VITE_ASSET__pPFoN6h7__"